<script>
    import { translateText } from 'lang'
    import Days from './elements/days.svelte';
    import { statusType } from './elements/data';
    import { onDestroy } from 'svelte';
    export let onSetLoad;
    import { executeClient } from "api/rage";
    executeClient ("client.rewardslist.day.load");

    let rewardList = [];

    onSetLoad (true);
    const updateLoad = (json) => {
        onSetLoad (false);

        rewardList = JSON.parse(json)
    }

    import { addListernEvent } from 'api/functions';
    addListernEvent("rewardList.day.init", updateLoad);

    // Живой отсчёт: сервер шлёт остаток времени снимком при открытии, поэтому в UI
    // он "не шёл". Локально уменьшаем оставшиеся минуты раз в минуту.
    const tick = setInterval(() => {
        rewardList = rewardList.map(it =>
            (it.status === statusType.time && it.time > 0)
                ? { ...it, time: it.time - 1 }
                : it);
    }, 60000);
    onDestroy(() => clearInterval(tick));

    const onTake = (item) => {
        executeClient ("client.rewardslist.day.take", item.day);
    }
</script>

<div class="list1">
    {#each rewardList as item}
        <Days {item} on:click={() => onTake (item)}/>
    {/each}
</div>